module.exports = __webpack_public_path__ + "static/media/animatedBlob.839e144e.svg";